<template>
  <div v-show="loading" class="nt-loading">
    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'nt-loading',
  computed: {
    ...mapGetters(['loading'])
  }
}
</script>
